import * as React from "react";
import { Stack, Card } from "@origin-digital/ods-core";
import { Formik, Form } from "formik";
import RemoveSupplyPremiseBlock from "./RemoveSupplyPremiseBlock";
import RemoveSupplyContext from "src/context/RemoveSupplyContext";
import { useParams } from "react-router-dom";
import { RequestStatusEnum } from "src/components/Premises/types";
import RemoveSupplyPremiseBlockReadonly from "./RemoveSupplyPremiseBlockReadonly";
import RemoveSupplyServiceBlock from "./RemoveSupplyServiceBlock";
import RemoveSupplyServiceBlockReadonly from "./RemoveSupplyServiceBlockReadonly";
import { RemoveSupplyFormContentProps, RemoveSupplyFormValues } from "./types";

export const RemoveSupplyFormContent: React.FC<
  RemoveSupplyFormContentProps
> = ({ formValues }) => {
  const { draftInfo } = React.useContext(RemoveSupplyContext);
  const { requestId } = useParams<{ requestId: string }>();

  const isNew = draftInfo === null;
  const isDraft = draftInfo?.raw_request_status === RequestStatusEnum.DRAFT;
  const isSubmitted = !isNew && !isDraft;

  return (
    <Card outline>
      <Formik<RemoveSupplyFormValues>
        initialValues={formValues}
        onSubmit={() => {}}
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize={true}
      >
        <Form>
          <Stack space={{ xs: "xlarge", md: "xxlarge" }}>
            {!requestId && isNew && <RemoveSupplyPremiseBlock />}
            {(isDraft || isSubmitted) && (
              <RemoveSupplyPremiseBlockReadonly
                isSubmitted={isSubmitted}
                isDraft={isDraft}
              />
            )}
            {isDraft && <RemoveSupplyServiceBlock />}
            {isSubmitted && <RemoveSupplyServiceBlockReadonly />}
          </Stack>
        </Form>
      </Formik>
    </Card>
  );
};
